/**
 * Build a photo `src` URL.
 *
 * The detail-fetch worker downloads the hero photo to local content-addressed
 * storage; whenever a sha256 is present we point the browser at the local
 * /api/photos/{sha256} endpoint. Otherwise we fall back to the upstream CDN
 * URL so the UI degrades gracefully when the hero hasn't been mirrored yet
 * (CDN unavailable, brand-new car not yet detail-fetched, etc.).
 */
export function heroSrc(
  url: string | null | undefined,
  sha256: string | null | undefined,
): string | null {
  if (sha256) return `/api/photos/${sha256}`;
  if (url) return url;
  return null;
}
